import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {catchError, map, Observable, throwError} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ApiCodeMessage} from '../consts/api-code-message.constant';
import {ConfigParameterDto, PersonEntityDto} from "@/app/shared/models/nomenclator-model";
import {EntityDto} from "@/app/shared/models/entity-model";
import {DomSanitizer} from "@angular/platform-browser";
import {InvoiceDto} from "@/app/shared/models/invoice-model";
import {ConfigParameter} from "@/app/features/components/config-parameter/config-parameter";

@Injectable({
    providedIn: 'root'
})
export class Nomenclators {

    constructor(private _http: HttpClient, private domSanitizer: DomSanitizer) {
    }

    handleServiceError(error: HttpErrorResponse) {
        let mensajeError = undefined;
        if (error && error.error && error.error.error && typeof error.error.error === 'string') {
            mensajeError = error.error.error;
        } else if (error.error instanceof ErrorEvent) {
            console.error('Error:', error.error.message);
            mensajeError = `Error: ${error.error.message}`;
        } else {
            switch (error.status) {
                case 400:
                    console.error(`Error del backend, código: ${error.status}, `);
                    mensajeError = error.error.error;
                    break;
                case 403:
                    console.error(`Error del backend, código: ${error.status}, `);
                    mensajeError = error.error;
                    break;
                case 500:
                    console.error(`Error del backend, código: ${error.status} `);
                    break;
                case 503:
                    console.error(`Error del backend, código: ${error.status} `);
                    mensajeError = ApiCodeMessage.MSG_CODE_503;
                    break;
                default:
                    console.error(`Error: ${error} `);
                    mensajeError = error;
                    break;
            }
        }
        if (typeof mensajeError !== 'string') {
            mensajeError = '';
        }
        return throwError(() => mensajeError);
    }

    /*
   * Endpoint para obtener el listado de entidades
   */
    getEntitiesSimple(): Observable<any> {
        const headers = new HttpHeaders({
            accept: 'application/json',
        });
        return this._http
            .get<any>(environment.serviceNomEntity, {headers})
            .pipe(
                map((data) => data),
                catchError(this.handleServiceError),
            );
    }

    /*
   * Endpoint para obtener una entidad.
   */
    getEntityById(entityId: number): Observable<any> {
        const headers = new HttpHeaders({
            accept: 'application/json',
        });
        return this._http
            .get<any>(environment.serviceNomEntity + `/${entityId}`, {headers})
            .pipe(
                map((data) => data),
                catchError(this.handleServiceError),
            );
    }

    findAllEntities(pageNumber: number, pageSize: number, personId?: number, searchParam?: string): Observable<any> {
        const headers = new HttpHeaders({
            accept: 'application/json',
        });
        let queryParams = new HttpParams();
        personId !== undefined
            ? (queryParams = queryParams.append('personId', personId))
            : null;

        searchParam !== undefined
            ? (queryParams = queryParams.append('searchParam', searchParam))
            : null;

        pageNumber !== undefined
            ? (queryParams = queryParams.append('pageNumber', pageNumber))
            : null;
        pageSize !== undefined
            ? (queryParams = queryParams.append('pageSize', pageSize))
            : null;
        // sort !== undefined
        //     ? (queryParams = queryParams.append('sort', sort))
        //     : null;

        const options = {
            headers: headers,
            params: queryParams,
        };

        return this._http
            .get<any>(environment.serviceNomEntity + `/all`, options)
            .pipe(
                map((data) => data),
                catchError(this.handleServiceError),
            );
    }

    findAllEntitiesForStudent(personId: number, pageNumber: number, pageSize: number, searchParam?: string): Observable<any> {
        const headers = new HttpHeaders({
            accept: 'application/json',
        });
        let queryParams = new HttpParams();
        searchParam !== undefined
            ? (queryParams = queryParams.append('searchParam', searchParam))
            : null;
        pageNumber !== undefined
            ? (queryParams = queryParams.append('pageNumber', pageNumber))
            : null;
        pageSize !== undefined
            ? (queryParams = queryParams.append('pageSize', pageSize))
            : null;

        const options = {
            headers: headers,
            params: queryParams,
        };
        return this._http
            .get<any>(environment.serviceNomEntity + `/by-student/${personId}`, options)
            .pipe(
                map((data) => data),
                catchError(this.handleServiceError),
            );
    }

    findAllEntitiesByStudentIdAndEntityId(personId: number, entityId: number): Observable<any> {
        const headers = new HttpHeaders({
            accept: 'application/json',
        });

        return this._http
            .get<any>(environment.serviceNomEntity + `/by-student/${personId}/by-entity/${entityId}`, {headers: headers})
            .pipe(
                map((data) => data),
                catchError(this.handleServiceError),
            );
    }

    findAllEntitiesForMainTeacher(teacherId: number, pageNumber: number, pageSize: number, status?: string, searchParam?: string): Observable<any> {
        const headers = new HttpHeaders({
            accept: 'application/json',
        });
        let queryParams = new HttpParams();
        status !== undefined
            ? (queryParams = queryParams.append('status', status))
            : null;

        searchParam !== undefined
            ? (queryParams = queryParams.append('searchParam', searchParam))
            : null;

        pageNumber !== undefined
            ? (queryParams = queryParams.append('pageNumber', pageNumber))
            : null;
        pageSize !== undefined
            ? (queryParams = queryParams.append('pageSize', pageSize))
            : null;

        const options = {
            headers: headers,
            params: queryParams,
        };

        return this._http
            .get<any>(environment.serviceNomEntity + `/by-teacher/${teacherId}`, options)
            .pipe(
                map((data) => data),
                catchError(this.handleServiceError),
            );
    }

    findAssociationsByProfessorAndByEntityId(entityId: number): Observable<any> {
        const headers = new HttpHeaders({
            accept: 'application/json',
        });

        return this._http
            .get<any>(environment.serviceNomEntity + `/by-person-entity/${entityId}`, {headers: headers})
            .pipe(
                map((data) => data),
                catchError(this.handleServiceError),
            );
    }

    insertStatusPersonEntity(personEntity: PersonEntityDto): Observable<any> {
        const headers = new HttpHeaders({
            accept: 'application/json',
        });

        return this._http
            .post<any>(environment.serviceNomEntity + `/insert-person-entity`, personEntity, {headers: headers})
            .pipe(
                map((data) => data),
                catchError(this.handleServiceError)
            );
    }

    updateStatusPersonEntity(personEntity: PersonEntityDto): Observable<any> {
        const headers = new HttpHeaders({
            accept: 'application/json',
        });

        return this._http
            .put<any>(environment.serviceNomEntity + `/update-person-entity`, personEntity, {headers: headers})
            .pipe(
                map((data) => data),
                catchError(this.handleServiceError)
            );
    }

    insertEntity(entityDto: EntityDto, file?: File | null): Observable<any> {
        const formData = new FormData();
        formData.append(
            'dto',
            new Blob([JSON.stringify(entityDto)], {type: 'application/json'})
        );
        if (file) {
            formData.append('logoFile', file);
        }

        return this._http.post(environment.serviceNomEntity, formData, {
            headers: new HttpHeaders({accept: '*/*'}),
            responseType: 'json'
        })
        .pipe(
            catchError(this.handleServiceError)
        );
    }

    updateEntity(entityId: number, entityDto: EntityDto, file?: File | null): Observable<any> {
        const formData = new FormData();
        formData.append(
            'dto',
            new Blob([JSON.stringify(entityDto)], {type: 'application/json'})
        );

        if (file) {
            formData.append('logoFile', file);
        }

        return this._http
            .put<any>(environment.serviceNomEntity + `/${entityId}`, formData, {
                headers: new HttpHeaders({accept: '*/*'}),
                responseType: 'json'
            })
            .pipe(
                catchError(this.handleServiceError)
            );
    }

    deleteEntity(entityId: number): Observable<void> {
        const headers = new HttpHeaders({
            accept: 'application/json',
        });
        return this._http
            .delete<any>(environment.serviceNomEntity + `/${entityId}`, {headers})
            .pipe(
                map((data) => data),
                catchError(this.handleServiceError),
            );
    }

    getAllRole(): Observable<any> {
        const headers = new HttpHeaders({
            accept: 'application/json',
        });
        return this._http
            .get<any>(environment.serviceRole, {headers})
            .pipe(
                map((data) => data),
                catchError(this.handleServiceError),
            );
    }


    getAllConfigParameter(pageNumber: number, pageSize: number, isPrice: boolean, request?: string): Observable<any> {
        const headers = new HttpHeaders({
            accept: 'application/json',
        });

        let queryParams = new HttpParams();

        request !== undefined
            ? (queryParams = queryParams.append('searchParam', request))
            : null;

        isPrice
            ? (queryParams = queryParams.append('isPrice', isPrice))
            : null;

        pageNumber !== undefined
            ? (queryParams = queryParams.append('pageNumber', pageNumber))
            : null;

        pageSize !== undefined
            ? (queryParams = queryParams.append('pageSize', pageSize))
            : null;

        const options = {
            headers: headers,
            params: queryParams,
        };

        return this._http
            .get<any>(environment.serviceConfigParameter, options)
            .pipe(
                map((data) => data),
                catchError(this.handleServiceError)
            );
    }

    /*
    * Endpoint para obtener una entidad.
    */
    getConfigParameterById(configParameterId: number): Observable<any> {
        const headers = new HttpHeaders({
            accept: 'application/json',
        });
        return this._http
            .get<any>(environment.serviceConfigParameter + `/${configParameterId}`, {headers})
            .pipe(
                map((data) => data),
                catchError(this.handleServiceError),
            );
    }

    getConfigParameterByName(configParametername: string): Observable<any> {
        const headers = new HttpHeaders({
            accept: 'application/json',
        });
        return this._http
            .get<any>(environment.serviceConfigParameter + `/by-name/${configParametername}`, {headers})
            .pipe(
                map((data) => data),
                catchError(this.handleServiceError),
            );
    }

    /*
    * Endpoint para obtener una entidad.
    */
    getCourseInvoiceParameter(): Observable<any> {
        const headers = new HttpHeaders({
            accept: 'application/json',
        });
        return this._http
            .get<any>(environment.serviceConfigParameter + `/course-invoice-parameter`, {headers})
            .pipe(
                map((data) => data),
                catchError(this.handleServiceError),
            );
    }

    updateConfigParameter(configParameterDto: ConfigParameterDto): Observable<any> {
        const headers = new HttpHeaders({
            accept: 'application/json',
        });

        return this._http
            .put<any>(environment.serviceConfigParameter, configParameterDto, {headers: headers})
            .pipe(
                map((data) => data),
                catchError(this.handleServiceError)
            );
    }
}